if(window.location.pathname.includes("reports/properties")){

    function load_map(){

        var usa = {lat: 39.8282, lng: -98.5795};

        var map = new google.maps.Map(document.querySelector('.property-map'), {zoom: 3, center: usa});

        var bounds = new google.maps.LatLngBounds();
        var infowindow = new google.maps.InfoWindow();

        for(var i = 0;i<properties.length;i++){
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(properties[i]['latitude'], properties[i]['longitude']),
                map: map
            });

            bounds.extend(marker.position);

            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {
                    var html = [
                        "<div>",
                        properties[i]['address'],
                        "</div>"
                    ].join("");
                    infowindow.setContent(html);
                    infowindow.open(map, marker);
                }
            })(marker, i));

        }

        map.fitBounds(bounds);

    }

    $(document).ready(function(){

        if(typeof window.maps_loaded !== 'undefined'){
            load_map();
        }else{
            window.initMap = load_map;
        }

    });
    var options = {
        /* No ordering applied by DataTables during initialisation */
        "order": [],
        "columnDefs": [
            {
                searchable: false,
                orderable: false,
                targets: 0,
            },
            {
                "render": function(data, type, row){
                    return "<a href='/placement/edit/"+row.placement_id+"'>"+data+"</a>";
                },
                "targets": 2
            },
        ],
        "rowCallback": function(row, data, index) {
            const api = this.api();
            const pageInfo = api.page.info();
            $('td:eq(0)', row).html(pageInfo.start + index + 1);
        },
        "buttons": [
            {extend:"excel", text: '<i class="fas fa-file-download"></i>'}
        ]
    };

    $.each($(".data-table"), function(){
        $(this).data("options", options);
    });

    $("[name='property_search']").on("keyup", function(){
        let val = $(this).val();
        $.each($(".data-table"), function(){
            $(this).DataTable().search(val).draw();
        });
    });

}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/properties.js